import React, { useMemo } from "react";

import { useSelector } from "react-redux";
import { RideTextField } from "@rimac-seguros/ride-system-components";

import Regex from "@/utils/regex";
import { handleInputPercentage } from "@/utils/beneficiary-utils";
import { CustomDropdown } from "@/components/molecules/CustomDropdown";
import helpers from '@/utils/helpers'

export const FormAdditionalData = ({
  register,
  prefixControl,
  prefixError,
  watch,
  showPhoneAndEmail,
  isSmallScreen,
  loadingSave,
  setValue,
}) => {
  const isVE = helpers.validateVidaEndosable();
  const { relationshipList } = useSelector((state) => state.global);

  const getRelationshipList = useMemo(() => {
    return relationshipList
      .filter((_) => _.descripcion !== "Titular")
      .map((_) => ({
        label: _.descripcion,
        value: _.id,
      }));
  }, [relationshipList]);

  const handleInputPhone = (e) => {
    const el = e.target;
    el.value = el.value.replace(/[^0-9]/g, "");
  };

  return (
    <div className="grid gap-y-ride-gl-spacing-2xlarge lg:gap-x-ride-gl-spacing-2xlarge lg:gap-y-ride-gl-spacing-3xlarge lg:grid-cols-2">
      {showPhoneAndEmail && (
        <>
          <RideTextField
            {...register(`${prefixControl}.phone`, {
              required: isVE ? "Ingresa un celular" : "Este campo es obligatorio",
              minLength: {
                value: 9,
                message: "Formato inválido",
              },
              pattern: {
                value: Regex.phone,
                message: "Formato inválido",
              },
            })}
            aria-required
            label="Celular"
            autoComplete="off"
            size="large"
            maxLength={9}
            onInput={handleInputPhone}
            disabled={loadingSave}
            error={!!prefixError?.phone}
            errorMessage={prefixError?.phone?.message}
          />
          <RideTextField
            {...register(`${prefixControl}.email`, {
              required: isVE ? "Ingresa un correo electrónico" : "Este campo es obligatorio",
              pattern: {
                value: Regex.email,
                message: "Ingresa un correo válido",
              },
            })}
            aria-required
            label="Correo electrónico"
            autoComplete="off"
            size="large"
            disabled={loadingSave}
            error={!!prefixError?.email}
            errorMessage={prefixError?.email?.message}
          />
        </>
      )}
      <CustomDropdown
        hasSearch
        placeholder="Selecciona el parentesco"
        name={`${prefixControl}.relationship`}
        label="Parentesco"
        titleModal="Parentesco"
        isShowModal={isSmallScreen}
        iconResult="RideGlPinSolid"
        list={getRelationshipList}
        register={register}
        setValue={setValue}
        watch={watch}
        disabled={loadingSave}
        error={!!prefixError?.relationship}
        errorMessage={isVE ? "Elige un parentesco" : "Este campo es obligatorio"}
      />
      <RideTextField
        {...register(`${prefixControl}.percentage`, {
          required: isVE ? "Ingresa un porcentaje" : "Este campo es obligatorio",
          validate: (e) =>
            (Number(e) > 0 && Number(e) <= 100) || "Porcentaje inválido",
        })}
        label="Porcentaje de participación"
        aria-required
        autoComplete="off"
        size="large"
        suffix="%"
        disabled={loadingSave}
        error={!!prefixError?.percentage}
        errorMessage={prefixError?.percentage?.message}
        onInput={handleInputPercentage}
      />
    </div>
  );
};
